import { Capacitor } from '@capacitor/core'
import { CapacitorUpdater } from '@capgo/capacitor-updater'

export const initOta = async (): Promise<void> => {
  if (!Capacitor.isNativePlatform()) {
    return
  }

  await CapacitorUpdater.notifyAppReady()
}
